'use strict';

var _ = require('underscore');

// TimeSpan
// A utility library for converting milliseconds into
// log-friendly timespans
// (Ported from legacy code)
function TimeSpan(milliseconds) {
    this._milliseconds = +milliseconds || 0;
}

_.extend(TimeSpan.prototype, {
  valueOf: function () {
    return this._milliseconds;
  },
  toString: function () {
    return this.toJSON();
  },
  toJSON: function () {
    var msRemaining = this._milliseconds;

    var hours = Math.floor(msRemaining / (60 * 60 * 1000));
    msRemaining -= hours * (60 * 60 * 1000);

    var minutes = Math.floor(msRemaining / (60 * 1000));
    msRemaining -= minutes * (60 * 1000);

    var seconds = msRemaining / 1000;

    return [hours, minutes, seconds].join(':');
  },
  seconds: function () {
    return this._milliseconds / 1000;
  },
});

module.exports = TimeSpan;
